import { atom } from 'jotai';

export type FlowTofInfo = {
  mode: 1;
  area: 0x16;
  requestId: number;
  value: number;
  sampleIndex: number;
};

export const flowTofAtom = atom<FlowTofInfo | null>(null);

export const setFlowTofAtom = atom(
  null,
  (_get, set, next: FlowTofInfo | null) => {
    set(flowTofAtom, next);
  },
);
